import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-container">
        <Link to="/" className="logo">
            <img 
              src={logo} 
              alt="Home Aide CNA Bridge Logo" 
              className="logo-image"
            />
            <span>Home Aide CNA Bridge</span>
          </Link>
          
          <div className={`nav-container ${isMenuOpen ? 'open' : ''}`}>
            <nav className="nav">
              <ul>
                <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
                <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>About</Link></li>
                <li><Link to="/courses" onClick={() => setIsMenuOpen(false)}>Courses</Link></li>
                <li><Link to="/online-courses" onClick={() => setIsMenuOpen(false)}>Online Courses</Link></li>
                <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
              </ul>
            </nav>
            
            <div className="contact-info">
              <p>1305 S. 312th St Suite 202, Federal Way, WA 98003</p>
              <p>+1206 566 4676 / +1206 592 2115</p>
            </div>
          </div>
          
          <button className="menu-toggle" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;